/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect, useState } from 'react'
import { GroupSortIcon, SortIcon, Tick } from '../LandingHeader/Feedback/icons/Icons';

const SortByDropdown = React.memo(({sort = 'asc', sortBy = 'date', onSortChange, onSortByChange}) => {
    const sortOptions = [{value: 'asc', label: 'Ascending', icon: <SortIcon />}, {value: 'desc', label: 'Descending', icon: <SortIcon direction="desc" />}]
    const sortByOptions = [{value: 'title', label: 'Name'}, {value: 'Project.title', label: 'Project'}, {value: 'date', label: 'Do Date', default: true}, {value: 'createdAt', label: 'Date Added'}]
    const [showDropdown, setShowDropdown] = useState(false)

    useEffect(()=>{
        document.addEventListener('click', closeDropdown);

        return () => {
            document.removeEventListener('click', closeDropdown);
        }
    }, [])

    const closeDropdown = (e) => {
        if(!e.target?.closest('.actions-dropdown-container')){
            setShowDropdown(false);
        }
    }

    const toggleDropdown = (e) => {
        e.stopPropagation()
        e.preventDefault()
        setShowDropdown(!showDropdown)
    }

    return (
        <div className='flex-1 flex items-center justify-end actions-dropdown-container' css={{
            li: {
                '&:hover': {
                    background: `linear-gradient(0deg, rgba(255,255,255,0.80) 0%,rgba(255,255,255,0.80) 100%),linear-gradient(0deg,var(--accent-color) 0%,var(--accent-color) 100%),#FFF !important`,
                }
            }
        }}>
            <a href="#" className='group-sort-icon' onClick={toggleDropdown}>
                <span className={`group-sort-icon flex items-center w-[37px] justify-center p-[8px] gap-2`}>
                    {/* <SortIcon direction={sort} /> */}
                    <GroupSortIcon fill={showDropdown ? `var(--accent-color)` : 'none'} />
                </span>
            </a>
            {
                showDropdown &&
                <div className="actions-dropdown" css={{
                    top: '0 !important',
                    right: '37px !important'
                }}>
                    <ul>
                        {
                            sortOptions.map((option, index) => (
                                <li key={index}>
                                    <a className='action-item border-b-0 !rounded-none' href="javascript: void(0);" onClick={() => onSortChange(option.value)}>
                                        {option.icon}
                                        {option.label}
                                        <span className="flex-1 self-stretch"></span>
                                        {sort === option.value && <Tick color={`var(--accent-color)`} />}
                                    </a>
                                </li>
                            ))
                        }
                    </ul>
                    <div className='hr-line' css={{
                        '&:after': {
                            left: '0px !important',
                        }
                    }}></div>
                    <ul>
                        {
                            sortByOptions.map((option, index) => (
                                <li key={index}>
                                    <a className='action-item border-b-0 !rounded-none' href="javascript: void(0);" onClick={() => onSortByChange(option.value)}>
                                        {option.label}
                                        {option?.default && <span className='default-label opacity-30'>Default</span>}
                                        <span className="flex-1 self-stretch"></span>
                                        {sortBy === option.value && <Tick color={`var(--accent-color)`} />}
                                    </a>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            }
        </div>
    )
})

export default SortByDropdown